import { SkapaElement } from "@ingka/skapa-webc-element";
const styles = '@keyframes loading-bounce-small{0%,to{animation-timing-function:ease-in;transform:translateY(-160%)}40%{animation-timing-function:cubic-bezier(0,0,0,1);transform:translateY(20%)}}@keyframes loading-bounce{0%{animation-timing-function:ease-in;transform:translateY(0)}40%{animation-timing-function:ease-in;transform:translateY(2rem) scaleY(1)}50%{animation-timing-function:ease-out;transform:translateY(2rem) scaleY(.75)}60%{animation-timing-function:cubic-bezier(0,0,0,1);transform:translateY(2rem) scaleY(1)}to{transform:translateY(0)}}:host{animation:loading-bounce .7s infinite;border:var(--skapa-loading-ball-size,.5rem) solid var(--skapa-loading-ball-colour,rgb(var(--colour-semantic-informative,0,88,163)))!important;border-radius:64px;display:inline-block;height:0;margin-bottom:calc(2rem + var(--skapa-loader-message-margin, 0rem));transform-origin:bottom;width:0}:host([medium]),:host([small]){animation-name:loading-bounce-small;margin-bottom:0}:host([small]){--skapa-loading-ball-size:0.125rem}:host([medium]){--skapa-loading-ball-size:0.25rem}:host([primary]){--skapa-loading-ball-colour:rgb(var(--colour-neutral-7,17,17,17))}:host([secondary]){--skapa-loading-ball-colour:currentColor}';
const sizes = ["small", "medium", "large"];
const colours = ["emphasized", "primary", "secondary"];
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`<style>
    ${styles}
  </style>`;
  return { main: template };
}
class LoadingBall extends SkapaElement {
  constructor() {
    super();
    this.gatherProperties(["size", "colour"], this);
    const template = this.getTemplates(generateTemplate);
    const shadow = this.attachShadow({ mode: "open" });
    shadow.append(template.main.content.cloneNode(true));
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute("aria-label"))
      this.setAttribute("aria-hidden", "true");
  }
  get size() {
    return sizes.find((s) => this.hasAttribute(s)) || "large";
  }
  set size(value) {
    const target = sizes.find((s) => s === value);
    if (target) {
      sizes.forEach((s) => this.removeAttribute(s));
      if (target !== "large")
        this.setAttribute(target, "");
    }
  }
  get colour() {
    return colours.find((s) => this.hasAttribute(s)) || "emphasized";
  }
  set colour(value) {
    const target = colours.find((s) => s === value);
    if (target) {
      colours.forEach((s) => this.removeAttribute(s));
      if (target !== "emphasized")
        this.setAttribute(target, "");
    }
  }
}
LoadingBall.skapaTagName = "loading-ball";
LoadingBall.skapaDependencies = [];
export {
  LoadingBall
};
